import { createSlice } from '@reduxjs/toolkit';
import { IModuleFilter } from '../../app/admin/modules/service';
import { IModule } from '../../shared/interfaces/modules/IModule';
interface IInitialState {
  list: IModule[];
  filters: IModuleFilter;
}
const initialState: IInitialState = {
  list: [],
  filters: {
    name: '',
  },
};
const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {
    setModules: (state, action) => {
      state.list = action.payload;
      return state;
    },
    setModuleFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export default moduleSlice;
